<template>
    <div>
        <header>
            <section>
                <div class="col1">
                    <router-link id="logo" to="uploader"><h3>JustOneMore</h3></router-link>
                    <ul class="inline">
                        <li><router-link to="uploader">Uploader</router-link></li>
                            <li><a v-on:click="logout()">logout</a></li>
                    </ul>
                </div>
            </section>
        </header>
        <div >
            <!-- <div class="large-12 medium-12 small-12 cell">
                <label for="title">Title:</label>
                <input v-model.trim="uploadInfo.title" type="text" placeholder="you@email.com" id="email1" />
                <label for="author">Author:</label>
                <input v-model.trim="uploadInfo.author" />
                <label for="duration">Duration (in seconds please):</label>
                <input v-model.trim="uploadInfo.duration"  />
                <label for="description">Description:</label>
                <input v-model.trim="uploadInfo.description" />
                <label>File
                    <input type="file" id="file" ref="file" v-on:change="handleFileChange()"/>
                </label>
                <button v-on:click="submitFile()">Submit</button>
            </div> -->
          <div class="md-form container container-custom">
            <div id="divMessage" class="form-group">
              {{ message }}
            </div>
            <div class="form-group">
              <label >Title:</label>
              <input v-model.trim="uploadInfo.title" class="form-control" required>
            </div>
            <div class="form-group">
              <label>Author:</label>
              <input v-model.trim="uploadInfo.author" class="form-control" required>
            </div>
            <!-- <div class="form-group">
              <label >Duration (in seconds please):</label>
              <input v-model.trim="uploadInfo.duration" class="form-control" required>
            </div> -->
            <div class="form-group">
              <span>Story is original: </span><input style="width:auto;display:inline" type="checkbox" name="vehicle1" v-model="uploadInfo.original">
            </div>
            <!-- <div>
              <span>Story is public: </span><input style="width:auto;display:inline" type="checkbox" name="vehicle1" v-model="uploadInfo.public">
            </div> -->
            <div class="form-group">
              <div class="form-check disabled">
                <input class="form-check-input" type="radio" disabled checked>
                <label style="margin-left:2%" class="form-check-label" for="exampleRadios3">
                  Private story
                </label>
              </div>
              <div data-toggle="tooltip" title="Public stories coming soon, get ready!" v-on:click="showPublicAlert()" class="form-check disabled">
                <input style="margin-left:-6.5%" class="form-check-input" type="radio" disabled>
                <label class="form-check-label" for="exampleRadios2">
                  Public story
                </label>
              </div>
            </div>
            <div style="display:none" id="alertPublic" class="alert alert-warning alert-dismissible fade show" role="alert">
              You will soon be able to make your stories public and share them, get ready!
              <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="form-group" style="margin-top:10px">
              <label for="exampleInputEmail1">Description:</label>
              <textarea v-model.trim="uploadInfo.description" class="form-control" required></textarea>
            </div>
            <div class="form-group">
              <label for="exampleFormControlSelect1">Story language:</label>
              <select value="English" v-model.trim="uploadInfo.language" class="form-control" v-on:change="handleLanguageChange" required>
                <option selected="selected">English</option>
                <option>Spanish</option>
                <option>Other</option>
              </select>
               <input id="inputLanguage" v-model.trim="uploadInfo.other" class="form-control" placeholder="Other language">
            </div>
            <div class="form-group" style="margin-top:10px">
              <span>Please choose your file (mp3): </span>
              <label class="btn btn-primary">
                  <span id="filename">Browse File</span> <input preload="auto" id="fileupload" type="file" style="display: none;" v-on:change="handleFileChange">
              </label>
            </div>
            <button v-on:click="submitFile()" class="btn btn-primary">Submit</button>
          </div>
          <audio id="my-audio"></audio>
        </div>
    </div>
</template>

<script>
/* eslint-disable */
import ApiService from '@/services/api/Mainapi'
import { fbStorage } from '@/firebaseConfig.js'
let testduration = ''
export default {
  data () {
    return {
      loading: true,
      message: '',
      file: '',
      audiourl: 0,
      duration: '',
      uploadInfo: {
        title: '',
        description: '',
        author: '',
        original: false,
        location: '',
        coverurl: 'https://firebasestorage.googleapis.com/v0/b/jomapp-firebase.appspot.com/o/01_cover.jpg?alt=media&token=a39d508c-4aff-4ce6-b260-f386757b7ce4',
        language: '',
        other: '',
        public: false,
      },
    }
  },
  methods: {
    logout () {
      // ApiService.signOut().then(() => {
        //this.$store.dispatch('clearData')
        // ApiService.current_user = nil
        // ApiService.current_user_id = nil
        localStorage.id = ''
        localStorage.dataat = ''
        this.$router.push('/login')
      // }).catch(err => {
      //   addErrorMessage()
      //   console.log(err)
      // })
    },
    submitFile () {
      // let formData = new formData()
      // formData.append('file', this.file)
      this.otherLanguage()
      if (this.checkValidation()) {
        this.addErrorMessage()
        return;
      }
      var storageRef = fbStorage.ref('audios').child((new Date()) + '-' + this.file.name);
      const uploadingTask = storageRef.put(this.file);
      // alert("FILE: " + this.file.type)
      // alert("FILE DURATION: " + this.file.duration)
      uploadingTask
        .then(snap => {
          snap.ref.getDownloadURL().then((url) => {
            // alert("URL" + url)
            this.uploadInfo.location = url
            this.uploadInfo.duration = this.duration
            // console.log("uploadinfo duration: " + testduration)
            this.audiourl = url
            var userID = localStorage.getItem('id')
            var coverurl = this.getCoverImg()
            // alert('Cover: ' + coverurl)
            ApiService.uploadAudio(this.uploadInfo, userID, testduration, coverurl)
              .then(response => {
                this.message = "Audio successfully submitted. Kids will love your new story."
                $('#divMessage').addClass("alert").addClass("alert-success")
              })
              .catch(error => {
                console.log(error)
                this.addErrorMessage()
              })
          })
          .catch(err => {
            console.log(err)
            this.addErrorMessage()
          })
        })
        .catch(err => {
          console.log(err)
          this.addErrorMessage()
        })              
        .finally(function() {
            //this.loading = false
        });
    },
    handleFileChange () {
      this.file = $("#fileupload")[0].files[0];
      $("#filename").text(this.file.name)
      var tempURL = URL.createObjectURL(this.file);
      // alert('AUDIO URL' + obUrl)
      $('#my-audio').attr('src', tempURL)
      setTimeout(function () {
        var audiotest = $("#my-audio")[0];
        // alert("SETTIMEOUT duration: " + audiotest.duration)
        testduration = audiotest.duration
        // console.log("Uloadinfo: " + testduration)
      }, 500);
    },
    addErrorMessage() {
      if (this.message == '') {
        this.message = "Sorry something went wrong. Please report if it continues"
      }
      $('#divMessage').addClass("alert").addClass("alert-danger")
    },
    handleLanguageChange () {
      if (this.uploadInfo.language == 'Other') {
        $('#inputLanguage').show()
      }
      else {
        $('#inputLanguage').hide()
      }
    },
    otherLanguage () {
      if (this.uploadInfo.language == 'Other') {
        $('inputLanguage').prop('required', true)
        this.uploadInfo.language = this.uploadInfo.other
      } else {
        $('inputLanguage').prop('required', false)
      }
    },
    checkValidation () {
      this.message = ''
      var validationErrors = false
      if (this.uploadInfo.title == '' || this.uploadInfo.description == '' ||
      this.uploadInfo.author == '' || this.uploadInfo.language == '') {
        this.message = 'Please fill out all the information.'
        validationErrors = true
      }
      if (this.file.type != 'audio/mp3' & this.file.type != '') {
        this.message += "\n" + `
        Please choose a MP3 file`
        validationErrors = true
      }
      return validationErrors
    },
    showPublicAlert() {
      $('#alertPublic').show()
      $('#alertPublic').alert()
    },
    testfunc (e) {
    },
    getCoverImg() {
      var coverURL = ''
      var images = [
        'https://firebasestorage.googleapis.com/v0/b/jomapp-firebase.appspot.com/o/defaultcover%2Fjom_generic_cover_01_1000x1000.jpg?alt=media&token=455b0707-7d6a-46b7-a577-152fc04ecf6c',
        'https://firebasestorage.googleapis.com/v0/b/jomapp-firebase.appspot.com/o/defaultcover%2Fjom_generic_cover_02_1000x1000.jpg?alt=media&token=29b0e839-da4c-4178-b6f4-57d55e90d67a',
        'https://firebasestorage.googleapis.com/v0/b/jomapp-firebase.appspot.com/o/defaultcover%2Fjom_generic_cover_03_1000x1000.jpg?alt=media&token=fd7915a5-52d3-4365-848a-be7a5267b67b',
        'https://firebasestorage.googleapis.com/v0/b/jomapp-firebase.appspot.com/o/defaultcover%2Fjom_generic_cover_04_1000x1000.jpg?alt=media&token=2b7f5136-8fe6-452a-afdf-6151443adc19',
        'https://firebasestorage.googleapis.com/v0/b/jomapp-firebase.appspot.com/o/defaultcover%2Fjom_generic_cover_05_1000x1000.jpg?alt=media&token=66c3cfe0-7052-4576-af9f-ff4ab49b5e23',
        'https://firebasestorage.googleapis.com/v0/b/jomapp-firebase.appspot.com/o/defaultcover%2Fjom_generic_cover_06_1000x1000.jpg?alt=media&token=195ac134-a8f8-495d-98e4-b9dadc531d9a'
      ]
      var randomNumber = Math.floor(Math.random()*images.length);
      return images[randomNumber]
    }
  }
}
</script>

<style>
  body {
    background-color: white;
  }
  .container-custom {
    max-width: 450px;
    margin-top: 20px;
  }
  textarea {
    min-height: 125px;
  }
  #logo {
    position: fixed;
    display: flex;
  }
  #inputLanguage {
    margin-top: 10px;
    display: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/Uploader.vue